import React from "react";
import Portfolio from "../../components/portfolio/Portfolio";
import Slider from "../../components/slider/slider";

const Weddings = () =>{
    const collage = [
        "/images/weddings/wedp1.webp",
        "/images/weddings/wedp2.webp",
        "/images/weddings/wedp3.webp",
        "/images/weddings/wedp5.webp",
        "/images/weddings/wedp6.webp",
        "/images/weddings/wedp8.webp",
        "/images/weddings/wedp10.webp",
        "/images/weddings/wedp11.webp",
        "/images/weddings/wedp12.webp",
        "/images/weddings/wedp13.webp",
        "/images/weddings/wedp14.webp",
        "/images/weddings/wedp15.webp",
        "/images/weddings/wedp16.webp",
        "/images/weddings/wedp17.webp",
        "/images/weddings/wedp19.webp",
        "/images/weddings/wedp20.webp",
        "/images/weddings/wedp21.webp",
        "/images/weddings/wedp22.webp",
        "/images/weddings/wedp23.webp",
        "/images/weddings/wedp24.webp",
        "/images/weddings/wedp25.webp",
        "/images/weddings/wedp26.webp",
        "/images/weddings/wedp27.webp",
        "/images/weddings/wedp28.webp",
        "/images/weddings/wedp29.webp",
        "/images/weddings/wedp30.webp",
        "/images/weddings/wedp31.webp",
        "/images/weddings/wedp32.webp",
        "/images/weddings/wedp33.webp",
        "/images/weddings/wedp34.webp",
        "/images/weddings/wedp35.webp",
        "/images/weddings/wedp36.webp"
    ];
    
    return(
        <>
      
            <Portfolio collage={collage} title="WEDDINGS" text="Preserving every heartfelt moment and romantic detail, I specialize in crafting timeless photographs that capture the love and magic of your special day. Let me tell your unique love story through the lens, creating memories that will last a lifetime."/>
            <Slider/>
            </>
    )
}

export default Weddings